import { EditAction } from '../shared/enum/EditAction';
import { ClippingParameterModel } from './ClippingParameterModel';

export interface ClientClipperFilterModel {
    id: number,
    clientClipperId: number,
    clippingParameter: ClippingParameterModel | null,
    clippingParameterValue: string,
    userId: number | null,
    editAction: EditAction
}

export const clientClipperFilterModelInitial: ClientClipperFilterModel = {
    id: 0,
    clientClipperId: 0,
    clippingParameter: null,
    clippingParameterValue: '',
    userId: null,
    editAction: EditAction.NONE
};